



































































































import { ref, computed, defineComponent, watch } from '@vue/composition-api';
import ChartsBar from '../charts-bar.vue';
import ChartsLine from '../charts-line.vue';
import SelectNav from '../select-nav.vue';
import MapTable from '../map-table.vue';
import ModuleTitle from '../module-title.vue';
import { useOriginData } from '../../hooks/origin-data';
import { createFilterForm } from '../../filter';
import { handleWarningMessageToast } from '@/common/util';
import {SelectorsType } from '../../types';
import throttle from 'lodash/throttle';
import IconText from '../iconText.vue';

const defaultActive = [
    'dsp',
    '用户增长',
    '游戏中心',
    '合伙人视频',
    '搜索',
    '侧边栏-外露小程序',
    '侧边栏-小程序',
    '非常规渠道',
    '桌面',
    '私信'
]

export default defineComponent({
    name: "origin-data", // 来源分析
    components: {
        ModuleTitle,
        ChartsBar,
        ChartsLine,
        SelectNav,
        MapTable,
        IconText
    },
    props: {
        tabActive: {
            type: String,
            default: ''
        },
        appId: {
            type: String,
            required: true
        },
        gameType: {
            type: String,
            required: true,
        }
    },
    setup(props, context) {
        const {
            fillterForm,
            dashboardData,
            selectList,
            chartLoading,
            getDashboard,
            corePannelBarChartData,
            corePannelLineChartData,
            getCorePannelLineChart,
            getBarChart,
            getTableChart,
            tableData,
            downLoading,
            tableDownload,
        } = useOriginData(props, context)
        const allLoading = ref(false);
        const chartsComponents = ref(null) as any;
        const searchOriginSelect = ref<string[]>([]);
        const searchOriginSelectType = ref("new_user_cnt");
        const chartsStatus = ref(1);
        const originSelectOptions = ref<{name: string, value: string}[]>([]);
        const indexSelectOptions = ref<SelectorsType[]>([]);

        // 点击重置
        function clicRest() {
            const conditions = dashboardData.value.conditions
            fillterForm.value = createFilterForm(conditions, props.appId);
            // fillterForm.value = createFilterForm(conditions, 'ks652458996766419301');
        }

        // 筛选条件变化时清空当前页面所有数据
        function clearAllChartData() {
            const selectValue = [] as SelectorsType[];
            const selectOption = [] as {name: string, value: string}[];
            // 读取用户维度下拉数据
            dashboardData.value.panels[0].charts[0].selectors.map((item: SelectorsType) => {
                if(item.fieldName !== 'p_date' && item.fieldName !== 'app_id' && item.fieldName !== 'minigame_from_v2_1_level_name') {
                    selectValue.push(item);
                }
            });
            // 获取来源下拉数据
            dashboardData.value.panels[0].charts[0].conditions.find((m: any) => m.fieldName === 'data_from').options.map((item: {name: string, value: string}) => {
                selectOption.push(item);
            });
            originSelectOptions.value = selectOption;
            indexSelectOptions.value = selectValue;
            searchOriginSelect.value = [];
            // 初始化来源选中
            selectOption.map((m: {name: string, value: string}) => {
                if(defaultActive.includes(m.value)) {
                    searchOriginSelect.value.push(m.value)
                }
            });
            corePannelLineChartData.value = null;
            corePannelBarChartData.value = null;
            tableData.value = null;
        }

        // 当前展示的table 数据是否已经准备好，没有不展示下载按钮
        const tableDataOK = computed(() => {
            return !!tableData.value;
        })

        // 页面初始化
        async function init() {
            // 接口请求顺序 1、incomeData.ts 里的 getDashboard，getDashboard返回查询条件后才会触发watch，init()在watch内
            allLoading.value = true;
            Promise.all([
                // 清空当前页面所有数据
                clearAllChartData(),
                // 获取核心概览-折现图chart
                getCorePannelLineChart(searchOriginSelect.value, searchOriginSelectType.value),
                getBarChart(searchOriginSelect.value, searchOriginSelectType.value),
                getTableChart()
            ]).finally(() => {
                allLoading.value = false;
                context.emit('loadOver', allLoading.value);
                console.log('所有接口请求完毕')
            })
        }

        // 更新echarts数据
        async function searchSelectChange(e: string[]) {
            corePannelLineChartData.value = null;
            corePannelBarChartData.value = null;
            await getCorePannelLineChart(searchOriginSelect.value, searchOriginSelectType.value);
            await getBarChart(searchOriginSelect.value, searchOriginSelectType.value)
        }

        // 下载表格
        function clickTableDown() {
            if(downLoading.value) {
                handleWarningMessageToast('正在下载表格中...');
                return;
            }
            tableDownload();
        }

        // 防止连续点击
        const clickTableDownThrottle = throttle(clickTableDown, 1000, { 'trailing': false })

        watch(
            () => fillterForm.value,
            (val) => {
                if(allLoading.value) {
                    handleWarningMessageToast('操作太频繁了，请等一等数据~')
                    return;
                }
                // 页面初始化 之前还会请求 getDashboard，getDashboard返回筛选条件后才会触发watch
                init();
            },
            {
                deep: true
            }
        );
        watch(
            () => props.appId,
            async (val) => {
                if(allLoading.value) {
                    handleWarningMessageToast('操作太频繁了，请等一等数据~')
                    return;
                }
                // 重新请求dashbord，会重置所有筛选条件，触发上方的watch
                await getDashboard();
            }
        );


        return {
            chartsComponents,
            clicRest,
            fillterForm,
            chartLoading,
            corePannelBarChartData,
            corePannelLineChartData,
            allLoading,
            searchOriginSelect,
            searchOriginSelectType,
            searchSelectChange,
            chartsStatus,
            selectList,
            originSelectOptions,
            indexSelectOptions,
            tableData,
            tableDataOK,
            downLoading,
            clickTableDownThrottle
        }
    }
})
